
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/26-d",
      function () {
        return require("private-next-pages/promotion/26-d.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/26-d"])
      });
    }
  